// extracted by mini-css-extract-plugin
module.exports = {"pagination":"EventPagination_pagination__QVoTw","active":"EventPagination_active__2WzPq","disabled":"EventPagination_disabled__1HuDw"};